import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Box, TextField, InputAdornment, Typography } from '@mui/material';
import { useDebounce } from '../../../Hooks/useDebounce';
import CustomDialog from '../../../Components/Dialog/CustomDialog';

const PurchaseDialog = function PurchaseDialog({
  open,
  handleClose,
  title,
  id,
  onSubmit,
  purchaseData,
  unitPrice,
}) {
  const intl = useIntl();

  const [cost, setCost] = useState(null);
  const [creditsSMSQuantity, setCreditsSMSQuantity] = useState(null);
  const [debouncedCost] = useDebounce(cost, 600);
  const [debouncedCreditsSMSQuantity] = useDebounce(creditsSMSQuantity, 600);

  useEffect(() => {
    if (open && typeof purchaseData !== 'boolean') {
      setCreditsSMSQuantity(purchaseData.creditsSMSQuantity || 0);
      setCost(purchaseData.cost || 0);
    }
  }, [open, purchaseData]);

  useEffect(() => {
    if (
      creditsSMSQuantity !== null &&
      debouncedCreditsSMSQuantity === creditsSMSQuantity
    )
      setCost(
        debouncedCreditsSMSQuantity !== '' &&
          !isNaN(debouncedCreditsSMSQuantity)
          ? (debouncedCreditsSMSQuantity * unitPrice).toFixed(2)
          : ''
      );
  }, [debouncedCreditsSMSQuantity]);

  useEffect(() => {
    if (cost !== null && cost === debouncedCost)
      setCreditsSMSQuantity(
        debouncedCost !== '' && !isNaN(debouncedCost)
          ? (debouncedCost / unitPrice).toFixed(0)
          : ''
      );
  }, [debouncedCost]);

  const handleCreditsSMSQuantityChange = (e) => {
    if (!(parseInt(e.target.value, 10) <= 0))
      setCreditsSMSQuantity(e.target.value);
  };

  const handleCostChange = (e) => {
    if (!(parseFloat(e.target.value) <= 0)) setCost(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit({
      id: purchaseData?.id || 'new-purchase',
      cost: parseFloat(cost),
      unitPrice,
      creditsSMSQuantity: parseInt(creditsSMSQuantity, 10),
    });
  };

  const reset = () => {
    setCost(null);
    setCreditsSMSQuantity(null);
  };

  return (
    <CustomDialog
      id={id}
      title={title}
      open={open}
      close={(_, reason) => {
        if (reason !== 'clickaway' && reason !== 'escapeKeyDown') {
          handleClose();
          reset();
        }
      }}
      notRequiredFields
      messageDialog
      maxWidth="sm"
      fullWidth
      onSubmit={handleSubmit}
      submitDisabled={!(cost && creditsSMSQuantity)}
      noBackdrop
      noForm
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '16px',
          }}
        >
          <TextField
            id="cost-txtField"
            onChange={handleCostChange}
            label={intl.messages.COST}
            required
            fullWidth
            value={cost}
            type="number"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">€</InputAdornment>
                ),
              },
            }}
          />
          <TextField
            id="quantity-txtField"
            onChange={handleCreditsSMSQuantityChange}
            label={intl.messages.CREDIT_SMS_QUANTITY}
            required
            fullWidth
            value={creditsSMSQuantity}
            type="number"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start"> </InputAdornment>
                ),
              },
            }}
          />
        </Box>
        <Typography variant="body1">
          {intl.messages.PURCHASE_DIALOG_CONTENT}
        </Typography>
      </Box>
    </CustomDialog>
  );
};

export default PurchaseDialog;
